export const firebaseConfig = {
    apiKey: "AIzaSyBnQB-6u9Rzm7nANdTHBMuldUA92nhWl-c",
    authDomain: "wix-shortlink.firebaseapp.com",
    projectId: "wix-shortlink",
    storageBucket: "wix-shortlink.appspot.com",
    messagingSenderId: "957087175042",
    appId: "1:957087175042:web:dd7c20cc7921ae49bcbf9b"
};